<template>
  <div id="data-list-list-view" class="data-list-container">
    <vs-popup :title="$t('skillDetails.action2.a3')" :active.sync="CancelEmail">
      <div class="con-exemple-prompt">
        <div class="con-exemple-prompt">
          {{FeedbackData}}
          {{$t('skillDetails.action2.a5')}} <b>{{FeedbackData.inviteeEmail}}</b> ?
        </div>
        <vs-button class="ml-4 mt-4 float-right" @click="confirmCancelEmail(FeedbackData)">
          {{$t('skillDetails.action2.a7')}}
        </vs-button>
      </div>
    </vs-popup>

    <vs-popup :title="$t('skillDetails.action2.a17')" :active.sync="ExtendEmail">
      <div class="con-exemple-prompt">
        <div class="con-exemple-prompt">
          {{$t('skillDetails.action2.a18')}} <b>{{FeedbackData.inviteeEmail}}</b> ?
        </div>
        <vs-button class="ml-4 mt-4 float-right" @click="confirmExtendEmail(FeedbackData)">
          {{$t('skillDetails.action2.a7')}}
        </vs-button>
      </div>
    </vs-popup> 

    <vs-popup :title="$t('skillDetails.action2.a20')" :active.sync="confirmScheduleEmail">
      <div class="con-exemple-prompt">
        <div class="con-exemple-prompt">
          {{$t('skillDetails.action2.a19')}} <b>{{FeedbackData.inviteeEmail}}</b> ?
        </div>
        <vs-button class="ml-4 mt-4 float-right" @click="confirmresetScheduleEmail(FeedbackData)">
          {{$t('skillDetails.action2.a7')}}
        </vs-button>
      </div>
    </vs-popup>

    <h1>{{$t('coachLogin.trainee.raterList')}} {{traineeName}}</h1>

    <vs-table :data="inviteeData">
      <template slot="thead">
        <vs-th sort-key="inviteeEmail">{{$t('tblHeadings.th3')}}</vs-th>
        <vs-th sort-key="inviteUserName">{{$t('tblHeadings.th4')}}</vs-th>
        <vs-th sort-key="skillCount" class="text-primary">{{$t('tblHeadings.th5')}}</vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr @click="CompetenciesFeedback(inviteeGroup)" v-for="(inviteeGroup, index) in data" :key="index">
          <vs-td>
            {{ inviteeGroup[0].inviteeEmail }}
          </vs-td>
          <vs-td>
            {{ inviteeGroup[0].inviteUserName }}
          </vs-td>
          <vs-td>
            <b style="color:#9DCD5B;">{{ inviteeGroup.length }}</b>
          </vs-td>
          
          <template class="expand-user" slot="expand">
            <div id="data-list-list-view1" class="data-list-container" style="width:100%">
              <vs-table :data="inviteeGroup">
                <template slot="thead">
                  <!-- Spans the first 2/3 of the row to push the date to the right -->
                  <vs-th style="width: 80%;">{{$t('tblHeadings.th20')}}</vs-th>
                  <vs-th style="width: 34%;">Next Survey Date</vs-th>
                </template>

                <template slot-scope="{data: innerData}">
                  <vs-tr v-for="(allcompentency, idx) in innerData" :key="idx">
                    
                    <vs-td style="width: 66%;">
                      <p class="product-name font-medium truncate">
                        <a :href="'/user/skill-details/'+allcompentency.traineeCompetenciesId">
                          {{allcompentency['endorsementInvitePrgms'][allcompentency['endorsementInvitePrgms'].length - 1].progressMeasureId}}
                        </a>
                      </p>
                    </vs-td>
                    
                    <vs-td style="width: 34%;">
                      <div class="flex items-center" style="color: #626262; font-weight: 500;">
                        <i class="feather icon-calendar mr-2"></i>
                        <span>{{ getNextSurveyDate(allcompentency['endorsementInvitePrgms'][allcompentency['endorsementInvitePrgms'].length - 1].externalFeedback) }}</span>
                      </div>
                    </vs-td>

                  </vs-tr>
                </template>
                
              </vs-table>
            </div>
          </template>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
import i18n from "@/i18n/i18n";

import baseData from "@/i18n/i18n-en-Data-DPM.js";           
import deepData from "@/i18n/i18n-en-deep-Data.js";       
import pciData from "@/i18n/i18n-en-pci-Data-Coach.js";         
import peopletreeData from "@/i18n/i18n-en-peopletree-Data.js"; 

function getSkillNameFromSources(parentId) {
  const sources = [deepData, pciData, peopletreeData, baseData];
  let foundNames = [];

  for (const rawSrc of sources) {
    if (!rawSrc) continue;
    
    let rootData = null;
    if (rawSrc.addNewSkill && rawSrc.addNewSkill.data) rootData = rawSrc.addNewSkill.data;
    else if (rawSrc.default && rawSrc.default.addNewSkill && rawSrc.default.addNewSkill.data) rootData = rawSrc.default.addNewSkill.data;
    else if (rawSrc['sc']) rootData = rawSrc;
    else if (rawSrc.default && rawSrc.default['sc']) rootData = rawSrc.default;
    else if (rawSrc.data) rootData = rawSrc.data;
    else if (rawSrc.default && rawSrc.default.data) rootData = rawSrc.default.data;

    if (!rootData) continue;

    for (const key in rootData) {
      if (rootData[key] && rootData[key].competencies) {
        const match = rootData[key].competencies.find(c => c.id === parentId);
        if (match && match.comp && !foundNames.includes(match.comp)) {
          foundNames.push(match.comp);
        }
      }
    }
  }

  if (foundNames.length > 1) {
    const specializedName = foundNames.find(name => name !== 'Informing others');
    if (specializedName) return specializedName;
  }

  return foundNames.length > 0 ? foundNames[0] : null;
}

export default {
  data () {
    return {
      selected: [],
      inviteeData: [],
      itemsPerPage: 100,
      CancelEmail: false,
      ExtendEmail: false,
      confirmScheduleEmail: false,
      extendEmailDisable: true,
      Schedule: false,
      cancel: false,
      traineeName: '',
      FeedbackData: [],
      external_tokens: []
    }
  },
  computed: {
    products () {
      return this.inviteeData ? Object.values(this.inviteeData).flat() : [];
    }
  },

  created () {
    var url = new URL(window.location.href)
    let usersId = url.searchParams.get('userId')
    let traineeName = url.searchParams.get('traineeName')
    
    if (usersId) {
      usersId = url.searchParams.get('userId')
      this.$vs.notify({
        title: i18n.t('notification.user.myRater.raterList.success.a1',{ traineeName: traineeName }),
        fixed: false,
        color:'success'
      });
    } else {
      usersId = this.$store.state.AppActiveUser.usersId
    }
    
    const query = {
      query: { id: usersId }
    }
    
    this.$store
      .dispatch('users/find', query)
      .then(res => {
        this.traineeName = res.data[0].firstName + ' ' + res.data[0].lastName
      }).catch(err => {})

    this.$store.dispatch('addSkill/findCompetency', {query: {usersId: usersId}})
      .then(res => {
        let id = []
        for (let i = 0; i < res.data.length; i++) {
          id.push(res.data[i].id)
        }
        
        this.$store.dispatch('endorsement-invite/find', {query: {traineeCompetenciesId: {$in: id}}})
          .then(res => {
            let uiData = res.data.map(invite => {
              let plainInvite = { ...invite };
              if (invite.endorsementInvitePrgms) {
                plainInvite.endorsementInvitePrgms = invite.endorsementInvitePrgms.map(prgm => ({ ...prgm }));
              } else {
                plainInvite.endorsementInvitePrgms = [];
              }
              return plainInvite;
            });

            for (let i = 0; i < uiData.length; i++) {
              let currentInvite = uiData[i];
              
              if (!currentInvite.endorsementInvitePrgms || currentInvite.endorsementInvitePrgms.length === 0) continue;
              
              let prgmIndex = currentInvite.endorsementInvitePrgms.length - 1;
              
              this.$set(currentInvite.endorsementInvitePrgms[prgmIndex], 'externalFeedback', []);

              this.$store.dispatch('external-feedback/find', {query: {endorsement_invite_prgms_id: currentInvite.endorsementInvitePrgms[prgmIndex].id}})
                .then(res1 => {
                  currentInvite.endorsementInvitePrgms[prgmIndex].externalFeedback = res1.data;
                }).catch({})
                
              let currentPrgmId = currentInvite.endorsementInvitePrgms[prgmIndex].progressMeasureId;

              let foundSkillName = null;
              if (currentPrgmId && typeof currentPrgmId === 'string' && currentPrgmId.includes('-')) {
                  const parts = currentPrgmId.split('-');
                  const parentId = parts[0] + "-" + parts[1];
                  foundSkillName = getSkillNameFromSources(parentId);
              }

              if (foundSkillName) {
                  currentInvite.endorsementInvitePrgms[prgmIndex].progressMeasureId = foundSkillName;
              } else if (currentPrgmId && currentPrgmId.length > 12) {
                this.$store.dispatch('trainee-competencies-prgms/find', {query: {progressMeasureId: currentPrgmId}})
                  .then(res1 => {
                    if(res1.data && res1.data.length > 0) {
                      this.$store.dispatch('trainee-competencies/find', {query: {id: res1.data[0].traineeCompetenciesId}})
                        .then(res2 => {
                          if(res2.data && res2.data.length > 0) {
                            const parts = res2.data[0].competencyId.split('-');
                            const parentId = parts[0] + "-" + parts[1];
                            const fallbackName = getSkillNameFromSources(parentId);
                            if (fallbackName) {
                              currentInvite.endorsementInvitePrgms[prgmIndex].progressMeasureId = fallbackName;
                            }
                          }
                        })
                    }
                  })
              }
            }

            function groupBy (array, key) {
              const result = {}
              array.forEach(item => {
                if (!result[item[key]]) {
                  result[item[key]] = []
                }
                result[item[key]].push(item)
              })
              return result
            }

            this.inviteeData = Object.values(groupBy(uiData, 'inviteeEmail'))
          })
          .catch(err => {})
      })
      .catch(err => {})
  },
  methods: {
    CompetenciesFeedback(data){},
    getNextSurveyDate(feedbacks) {
      if (!feedbacks || !feedbacks.length) return 'No schedule';
      
      const pending = feedbacks.filter(f => f.emailStatus === 0 && new Date(f.feedbackSentDate) > new Date());
      
      if (pending.length > 0) {
        pending.sort((a, b) => new Date(a.feedbackSentDate) - new Date(b.feedbackSentDate));
        const nextDate = new Date(pending[0].feedbackSentDate);
        return nextDate.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
      }
      return 'All Completed';
    },
    extendEmail (data) {
      this.ExtendEmail = true
      this.FeedbackData = data
    },
    confirmExtendEmail (data) {
      let dateDifference
      for (let i = 0; i < data['endorsementInvitePrgms'][0].externalFeedback.length; i++) {
        let firstDate = new Date(data['endorsementInvitePrgms'][0].externalFeedback[0].feedbackSentDate)
        let lastDate = new Date(data['endorsementInvitePrgms'][0].externalFeedback[1].feedbackSentDate)
        dateDifference = getDifferenceInDays(lastDate, firstDate)

        function getDifferenceInDays (date1, date2) {
          const diffInMs = Math.abs(date2 - date1)
          return diffInMs / (1000 * 60 * 60 * 24)
        }
      }

      for (let k = 1; k <= 2; k++) {
        const uuid4 = require('uuid4')
        const extFeedObj = {
          traineeName: this.traineeName,
          mailType: 'followup',
          inviteeEmail: data.inviteeEmail,
          inviteUserName: data.inviteUserName,
          skillName: data['endorsementInvitePrgms'][0]['progressMeasureId'],
          endorsementInvitePrgmsId: data['endorsementInvitePrgms'][0]['externalFeedback'][0]['endorsementInvitePrgmsId'],
          trainingDuration: new Date(new Date(data['endorsementInvitePrgms'][0]['externalFeedback'][5]['feedbackSentDate']).setDate(new Date(data['endorsementInvitePrgms'][0]['externalFeedback'][5]['feedbackSentDate']).getDate() + dateDifference * 2)),
          externalToken: uuid4(),
          lang: ((window.$cookies.get('locale') == 'es') ? 'es' : 'en'),
          externalTokenExpired: false,
          feedbackSentDate: new Date(new Date(data['endorsementInvitePrgms'][0]['externalFeedback'][5]['feedbackSentDate']).setDate(new Date(data['endorsementInvitePrgms'][0]['externalFeedback'][5]['feedbackSentDate']).getDate() + dateDifference * k)),
          emailStatus: 0
        }
        this.$store
          .dispatch('endorsementInvite/pushExternalFeedback', extFeedObj)
          .then(res => {}).catch(err => {})
      }
    },
    cancelEmail (data) {
      this.FeedbackData = data
      this.CancelEmail = true
    },
    confirmCancelEmail (data) {
      let deletedexternalToken = []
      let emailStatusCount = 0

      for (var i = 0; i < data['endorsementInvitePrgms'][0].externalFeedback.length; i++) {
        if ((new Date(data['endorsementInvitePrgms'][0].externalFeedback[i].feedbackSentDate)) > (new Date())) {
          deletedexternalToken.push(data['endorsementInvitePrgms'][0].externalFeedback[i].externalToken)
          if (data['endorsementInvitePrgms'][0].externalFeedback[i].emailStatus === 1) {
            emailStatusCount = emailStatusCount + 1
          }
        }
      }
      
      if (deletedexternalToken.length !== 0) {
        const query = {query: {externalToken: deletedexternalToken}}

        this.$store
          .dispatch('invitee-message-id/find', query)
          .then(res => {
            const gapFeedObj = {
              flag: 'cancel',
              feedbackId: data['endorsementInvitePrgms'][0].externalFeedback[0].id,
              messageId: res.data
            }
            this.$store
              .dispatch('external-feedback/patch', [data['endorsementInvitePrgms'][0].externalFeedback[0].id, gapFeedObj])
              .then(res1 => {
                this.$store
                  .dispatch('external-feedback/find', {
                    query: {
                      endorsementInvitePrgmsId: data['endorsementInvitePrgms'][0].externalFeedback[0].endorsementInvitePrgmsId,
                      currentGap: null
                    }
                  })
                  .then(res2 => {
                    if (emailStatusCount !== 0) {
                      this.$vs.notify({
                        color: 'primary',
                        title: i18n.t('notification.user.myRater.mailCancel.warning.c1'),
                        text:  i18n.t('notification.user.myRater.mailCancel.warning.c2')
                      })
                    } else {
                      this.$vs.notify({
                        color: 'primary',
                        title: i18n.t('notification.user.myRater.mailCancel.success.c1'),
                        text:  i18n.t('notification.user.myRater.mailCancel.success.c2')
                      })
                    }
                    
                    for (let j = 0; j < res2.data.length; j++) {
                      if (((new Date(res2.data[j].feedbackSentDate)) > (new Date()))) {
                        const ZeroGapData = {
                          emailStatus: 1,
                          externalTokenExpired: 1
                        }
                        this.$store
                          .dispatch('external-feedback/patch', [res2.data[j].id, ZeroGapData])
                          .then(res3 => {})
                          .catch(err => {})
                      }
                    }
                  })
                  .catch(err => {})
              })
              .catch(err => {})
          })
          .catch(err => {})
      }
    },

    ScheduleEmail (data) {
      this.confirmScheduleEmail = true
      this.FeedbackData = data
    },
    confirmresetScheduleEmail (data) {
      const query = {query: {id: data.traineeCompetenciesId}}
      this.$store
        .dispatch('addSkill/findCompetency', query)
        .then(traineeCompetency => {
            this.$store
              .dispatch('userManagement/fetchUser', traineeCompetency.data[0].usersId)
              .then(users => {
                  const query = {
                    query: {
                      endorsementInviteId: data.id
                    }
                  }
                  this.$store
                    .dispatch('endorsementInvite/fetchInviteePrgms', query)
                    .then(fetchInviteePrgms => {

                      const query1 = {query: {endorsementInvitePrgmsId: fetchInviteePrgms.data[0].id}}
                      this.$store
                        .dispatch('endorsementInvite/fetchFeeddata', query1)
                        .then(fetchFeeddata => {
                          for (var i = 0; i < fetchFeeddata.data.length; i++) {
                            if (((new Date(fetchFeeddata.data[i].feedbackSentDate)) > (new Date()))) {
                              
                              if (traineeCompetency.data[0].competencyId.length <= 12) {
                                const parts = traineeCompetency.data[0].competencyId.split('-');
                                const parentId = parts[0] + '-' + parts[1];
                                const resolvedName = getSkillNameFromSources(parentId);
                                this.InviteSkillName = resolvedName || traineeCompetency.data[0].competencyId;
                              } else {
                                this.InviteSkillName = '';
                              }
                              
                              const extFeedObj = {
                                traineeName: users.firstName + ' ' + users.lastName,
                                mailType: 'followup',
                                flag: 'RescheduleEmail',
                                inviteeEmail: data.inviteeEmail,
                                inviteUserName: data.inviteUserName,
                                skillName: this.InviteSkillName,
                                trainingDuration: traineeCompetency.data[0].trainingDuration,
                                endorsementInvitePrgmsId: fetchInviteePrgms.data[0].id,
                                externalToken: fetchFeeddata.data[i].externalToken,
                                lang: ((window.$cookies.get('locale') == 'es') ? 'es' : 'en'),
                                externalTokenExpired: false,
                                feedbackSentDate: fetchFeeddata.data[i].feedbackSentDate,
                                emailStatus: 0
                              }
                              
                              this.$store
                                .dispatch('external-feedback/patch', [fetchFeeddata.data[i].id, extFeedObj])
                                .then(res => {})
                                .catch(err => {})
                            }
                          }
                          this.$vs.notify({
                            color: 'primary',
                            title: i18n.t('notification.user.myRater.emailReschedule.success.s1'),
                            text:  i18n.t('notification.user.myRater.emailReschedule.success.s2')
                          })
                        })
                        .catch(err => {})
                    })
                    .catch(err => {})
                }
              )
              .catch(err => {})
          }
        )
        .catch(err => {})
    }
  }
}
</script>

<style lang="scss">
  .vs-table--not-data {
    padding: 10px;
    text-align: center;
    display: none;
  }
  #data-list-list-view {
    .vs-con-table {

      @media (max-width: 689px) {
        .vs-table--search {
          margin-left: 0;
          max-width: unset;
          width: 100%;

          .vs-table--search-input {
            width: 100%;
          }
        }
      }

      @media (max-width: 461px) {
        .items-per-page-handler {
          display: none;
        }
      }

      @media (max-width: 341px) {
        .data-list-btn-container {
          width: 100%;

          .dd-actions,
          .btn-add-new {
            width: 100%;
            margin-right: 0 !important;
          }
        }
      }

      .product-name {
        max-width: 23rem;
      }

      .vs-table--header {
        display: flex;
        flex-wrap: wrap;
        margin-left: 1.5rem;
        margin-right: 1.5rem;
        > span {
          display: flex;
          flex-grow: 1;
        }

        .vs-table--search{
          padding-top: 0;

          .vs-table--search-input {
            padding: 0.9rem 2.5rem;
            font-size: 1rem;

            &+i {
              left: 1rem;
            }

            &:focus+i {
              left: 1rem;
            }
          }
        }
      }

      .vs-table {
        border-collapse: separate;
        border-spacing: 0 1.3rem;
        padding: 0 1rem;

        tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
        }
      }

      .vs-table--thead{
        th {
          padding-top: 0;
          padding-bottom: 0;

          .vs-table-text{
            text-transform: uppercase;
            font-weight: 600;
          }
        }
        th.td-check{
          padding: 0 15px !important;
        }
        tr{
          background: none;
          box-shadow: none;
        }
      }

      .vs-table--pagination {
        justify-content: center;
      }
    }
  }
</style>
<style lang="stylus">
  .con-expand-users
    .con-btns-user
      display flex
      padding 10px
      padding-bottom 0px
      align-items center
      justify-content space-between
      .con-userx
        display flex
        align-items center
        justify-content flex-start
    .list-icon
      i
        font-size .9rem !important
</style>